import { dateFormatter, useTranslation } from '@fareye/common'
import { Card, Flex, Label, P, Span, styled } from '@fareye/ui'
import { getValueFromNestedKey, startCase } from '@fareye/utils'
import React from 'react'
import KeyValueDetails from './KeyValueDetails'

const FlexInfo = styled(Flex)`
  margin-bottom: 18px;
`
const SpaceContainer = styled.div`
  margin-bottom: 12px;
`
export const formatters: any = {
  startCase,
  dateFormatterTZ: dateFormatter
}
export default function ParcelSummary({ data, config }: any) {
  const { t } = useTranslation()
  const summaryData = config?.keyData
  function generateParcelInfo(
    ele: { key: string; label: string; formatter: string }[]
  ) {
    return ele.map(({ key, label, formatter }, index) => {
      let value = getValueFromNestedKey(data, key)
      let formattedValue =
        formatter && formatters[formatter]
          ? (value && formatters[formatter](value)) || '-'
          : (!!value && typeof value === 'string' ? t(value) : value) ||
            (value === 0 ? 0 : '-')
      if (formatter === 'startCase') {
        formattedValue = t(formattedValue)
      }
      return (
        <SpaceContainer key={`Space-${key}${index}`}>
          <KeyValueDetails
            keyStyle={{
              width: '40%'
            }}
            valueStyle={{
              width: '60%'
            }}
            backendKey={key}
            label={t(label)}
            value={formattedValue}
          />
        </SpaceContainer>
      )
    })
  }
  return (
    <Card bodyStyle={{ padding: '18px' }} variant="m">
      <P variant="h5" style={{ marginTop: '5px', marginBottom: '18px' }}>
        {t('Package Summary')}
      </P>
      {Object.values(summaryData).map((ele: any, index: number) => {
        return (
          <FlexInfo key={`${ele.label}${index}`} column>
            <Label style={{ marginBottom: '12px' }}>{t(ele.label)}</Label>
            {generateParcelInfo(ele.column)}
          </FlexInfo>
        )
      })}
    </Card>
  )
}
